import { AxiosResponse } from 'axios';
import { UserProfile } from '../../../../core/models/user-profile';
import backendHttpClient from '../../../http/axios/axios-http-client';
import { CreateUserProfileForOneTimeClientDTO } from './dto/create-user-profile-for-one-time-client-dto';
import { UpdateHealerUserProfileDTO } from './dto/update-healer-user-profile.dto';

const ENDPOINT = '/user-profile';

export interface HealerUserProfileGateway {
  createUserProfileForOneTimeClient(body: CreateUserProfileForOneTimeClientDTO): Promise<UserProfile>;
  getMyUserProfileAsHealer(): Promise<UserProfile>;
  updateHealerUserProfile(body: UpdateHealerUserProfileDTO): Promise<UserProfile>;
}

export class HealerUserProfileGateway implements HealerUserProfileGateway {
  async getMyUserProfileAsHealer(): Promise<UserProfile> {
    const endpoint = `${ENDPOINT}`;

    const response: AxiosResponse<UserProfile> = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });

    return response.data;
  }

  async updateHealerUserProfile(body: UpdateHealerUserProfileDTO): Promise<UserProfile> {
    const endpoint = `${ENDPOINT}/update`;

    const response: AxiosResponse<UserProfile> = await backendHttpClient.request({
      url: endpoint,
      method: 'POST',
      data: body,
    });

    return response.data;
  }

  async createUserProfileForOneTimeClient(body: CreateUserProfileForOneTimeClientDTO): Promise<UserProfile> {
    const endpoint = `${ENDPOINT}/one-time-client/create`;

    const response: AxiosResponse<UserProfile> = await backendHttpClient.request({
      url: endpoint,
      method: 'POST',
      data: body,
    });

    return response.data;
  }
}

export default HealerUserProfileGateway;
